import Avatar from "./Avatar";
import Icon from "./icons/Icon";
import "./PersonenListe.css";

/**
 * Wer ist da (Lobby, Platz zurueckholen). personen: [{ key, name, online,
 * ich, host }]. onEntfernen(key): X am Ende (nur Host). aktion(p): eigener
 * Knopf statt X (z. B. "Platz zurueckholen").
 * @category spiel
 */
export function PersonenListe({ personen, farbe, onEntfernen, aktion, leerText }) {
  if (!personen.length) return leerText ? <div className="leer-hinweis">{leerText}</div> : null;
  return (
    <ul className="personen">
      {personen.map((p) => (
        <li key={p.key} className={`person${p.online === false ? " offline" : ""}${p.ich ? " ich" : ""}`}>
          <Avatar name={p.name} farbe={farbe(p.name)} />
          <span className="person-name">
            {p.name}
            {p.online === false && <small> · offline</small>}
          </span>
          {p.host && <span className="person-marke host">Host</span>}
          {p.ich && !p.host && <span className="person-marke">Du</span>}
          {aktion && aktion(p)}
          {onEntfernen && !p.ich && !p.host && (
            <button type="button" className="person-weg" onClick={() => onEntfernen(p.key)} aria-label={`${p.name} entfernen`} title={`${p.name} entfernen`}>
              <Icon name="x" />
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}

export default PersonenListe;
